<template>
    <div>
        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block img-desktop-employee"></div>

                <section class="content-header">
                    <div class="container-fluid">
                        <div class="row mb-2 alert-container"></div>
                    </div>
                </section>

                <section class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-10 form-request-content-large">
                                <div class="request-title">
                                    <h1> Conditions Générales d'Utilisation</h1>
                                </div>

                                <div>
                                    <p v-for="(paragraph, index) in cgu" :key="index">
                                        {{ paragraph }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '../components/Footer';
    import { fetchDueLegalInformation } from '@/service/api/dues.api';

    export default {
        data() {
            return {
                cgu: []
            };
        },
        async created() {
            await this.fetchDueLegalInformation();
        },
        methods: {
            async fetchDueLegalInformation() {
                let { data } = await fetchDueLegalInformation();

                this.cgu = data.generalConditionsOfUsageText.legalAdvice;
            }
        },
        components: {
            Footer
        }
    }
</script>
